import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import "./MeActivity.css";
import { useRef } from "react";
import {
  FaRunning,
  FaBolt,
  FaMedal,
  FaTrophy,
  FaHeart,
  FaAppleAlt,
  FaDumbbell,
  FaHiking,
  FaSwimmer,
  FaBiking,
  FaUser
} from "react-icons/fa";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";

const getIconForType = (type = "") => {
  const lower = type.toLowerCase();

  if (lower.includes("goal")) return <FaRunning style={{ color: "#00C853" }} />;
  if (lower.includes("points")) return <FaBolt style={{ color: "#FFD600" }} />;
  if (lower.includes("badge") || lower.includes("milestone")) return <FaMedal style={{ color: "#FF6D00" }} />;
  if (lower.includes("challenge")) return <FaTrophy style={{ color: "#AB47BC" }} />;
  if (lower.includes("heart")) return <FaHeart style={{ color: "#E53935" }} />;
  if (lower.includes("diet") || lower.includes("food")) return <FaAppleAlt style={{ color: "#8BC34A" }} />;
  if (lower.includes("lift")) return <FaDumbbell style={{ color: "#546E7A" }} />;
  if (lower.includes("hike")) return <FaHiking style={{ color: "#795548" }} />;
  if (lower.includes("swim")) return <FaSwimmer style={{ color: "#03A9F4" }} />;
  if (lower.includes("bike") || lower.includes("cycle")) return <FaBiking style={{ color: "#00ACC1" }} />;

  return <FaUser style={{ color: "#607D8B" }} />;
};

const MeActivity: React.FC = () => {
  useCheckSessionHeartBeat();
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const beAddress = window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [activities, setActivities] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef<HTMLDivElement>(null);
  const [previousActivitiesCount, setPreviousActivitiesCount] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoadingVisible, setIsLoadingVisible] = useState(false);




  const fetchActivities = async () => {
    setIsFetching(true);
    setIsLoadingVisible(true);

    try {
      const response = await axios.get(`${beAddress}/api/user-activity`, {
        headers: {
          "user-uid": userUid,
        },
        params: {
          page,
          page_size: pageSize,
        },
        withCredentials: true,
      });

      const newRecords = response.data?.data?.activity_records || [];
      const totalPagesCount = response.data?.data?.total_pages || 1;

      setActivities(prev =>
        [...prev, ...newRecords].sort(
          (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
        )
      );

      setTotalPages(totalPagesCount);

    } catch (error) {
      console.error("Error fetching user activity:", error);
    } finally {
      setIsFetching(false);

      setTimeout(() => {
        setIsLoadingVisible(false);
      }, 800);
    }
  };


  useEffect(() => {
    fetchActivities();
  }, [page]);


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isFetching && page < totalPages) {
          setPage((prev) => prev + 1);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      }
    );

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      if (bottomRef.current) {
        observer.unobserve(bottomRef.current);
      }
    };
  }, [isFetching, page, totalPages]);


  useEffect(() => {
    const timelineItems = document.querySelectorAll(".MeActivity-timeline-item");
    timelineItems.forEach((item, idx) => {
      (item as HTMLElement).style.setProperty("--i", idx.toString());
    });
  }, [activities]);

  return (
    <div className="MeActivitylog-container">
      <h4>User Activity Timeline</h4>

      {activities.length === 0 ? (
        <p className="no-activity-message">No activity records found.</p>
      ) : (
        <div className="MeActivity-timeline">
          {activities.map((activity, index) => (
            <div
              className={`MeActivity-timeline-item ${index >= previousActivitiesCount ? "fade-in-new" : ""}`}
              key={index}
              data-index={index}
            >
              <div className="MeActivity-timeline-dot">
                {getIconForType(activity.event_type)}
              </div>
              <div className="MeActivity-timeline-content">
                <h4>{activity.event_type.replaceAll("_", " ")}</h4>
                <div className="MeActivity-section2">
                  <p>{activity.description}</p>
                  <span>{moment(activity.timestamp).format("MMM DD, YYYY • hh:mm A")}</span>
                </div>
              </div>
            </div>
          ))}

          {/* Bottom Sentinel to trigger next page load */}
          <div ref={bottomRef} style={{ height: "1px" }}></div>

          {/* Bottom loading spinner */}
          {isLoadingVisible && (
            <div className="bottom-loading-spinner">
              <div className="spinner4"></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MeActivity;